<template>
  <div class="endchallenge" :showall="allresults" :level="activeChallenge.level" :active="active" :failed="currentState.challengeFailed">
    <div class="end-splash" v-if="endCountdown>0">
      <div v-if="activeChallenge.number < 1" class="splash-header"  >Tutorial</div>
      <div v-if="activeChallenge.number>=1" class="splash-header">Challenge <b>{{ activeChallenge.number }}</b></div>
      <div class="splash-content" v-if="!currentState.challengeFailed">Completed!</div>
      <div class="splash-content" v-if="currentState.challengeFailed">Failed!</div>
      <div class="splash-footer">Redirecting to <b>your results</b> in <div class="splash-countdown">{{endCountdown}}</div></div>
    </div>
    <div class="end-header" v-show="endCountdown==0 && !showAll">
      <div class="challenge-level">{{ activeChallenge.level }}</div>
      <div class="challenge-title">
        <span v-if="activeChallenge.number>0" >Challenge {{ activeChallenge.number ? activeChallenge.number : '' }} </span>
        <span v-if="activeChallenge.number=='0'" >Tutorial </span>
        <i v-if="currentState.challengeFailed">Failed</i>
        <i v-if="!currentState.challengeFailed">Completed</i>
      </div>
      <div @click="exitChallenge()" class="action-button">
        Exit
      </div>
    </div>
    <div class="end-header all-results" v-show="endCountdown==0 && showAll">
      <div class="challenge-title">
        <span>All Challenge Results</span>
      </div>
      <div @click="exitChallenge()" class="action-button">
        Exit
      </div>
    </div>
    <div class="end-content" v-show="endCountdown==0 && !showAll">
      <h2>
        <span v-if="resultsLevel==3">Amazing Work!</span>
        <span v-if="resultsLevel==2">Good Job!</span>
        <span v-if="resultsLevel==1">Not Bad... But Room to Improve</span>
        <span v-if="resultsLevel==0"><span>You Can Do Better,</span> <b>Try Again?</b></span>
      </h2>
      <p v-if="resultsLevel==3">
        You clearly know how pumps work, the pumps kept running and you had no major issues.
      </p>
      <p v-if="resultsLevel==2">
        You clearly know how pumps work, the pumps kept running and you only had {{totalIncidents}} major issues.
      </p>
      <p v-if="resultsLevel==1 && !cummulativeTimeout">
        You’ve got the basics down but you had a few issues throughout the day
      </p>
      <p v-if="resultsLevel==1 && cummulativeTimeout">
        Not a good day.
        <span v-if="currentState.totalMinutesEmpty>currentState.towerEmptyTimeout">The water tower was empty for too long and the townsfolk went thirsty.</span>
        <span v-else>The Water Tower was over capacity for too long and sustained too much damage.</span>
      </p>
      <p v-if="resultsLevel==0">
        Not a good day.
        <span v-if="currentState.pumpIncidents>simulation.params.MAX_PUMP_INCIDENTS">Your pumps failed multiple times and the townsfolk went thirsty.</span>
        <span v-if="currentState.pumpIncidents<=simulation.params.MAX_PUMP_INCIDENTS && !currentState.towerOverflow">The water tower was empty for too long and the townsfolk went thirsty.</span>
        <span v-if="currentState.pumpIncidents<=simulation.params.MAX_PUMP_INCIDENTS && currentState.towerOverflow">The Water Tower was over capacity for too long and sustained too much damage.</span>
      </p>
      <div class="end-results" >
        <div class="detailed-results" :short="challenge.number<2">
          <div class="power-results dark-bg" :failed="currentState.totalPowerCost>limits.MIN_POWER">
            <div class="card-header">Power</div>
            <div class="card-content">
              <label>Total Power Used</label>
              <br />
              <b>{{ fix(currentState.totalPower,2) }}</b>
              <span>kWh</span>
              <div class="card-space"></div>
              <label>Power Cost</label>
              <br />
              <b>${{ fix(currentState.totalPowerCost, 2) }}</b>
            </div>
            <div
              class="card-footer"
              v-html="currentStars[0]"
            ></div>
          </div>
          <div class="main-results" :failed="currentState.repairCost>limits.MIN_REPAIR">
            <div class="pump-results dark-bg">
              <div class="card-header">Pumps</div>
              <div class="card-content">
                <div class="card-cell">
                  <label>Minor<br>Incidents</label>
                  <br />
                  <b>{{ currentState.pumpIssues }}</b> <img v-if="currentState.pumpIssues>=3" src="@/assets/img/alert-red.svg" valign="text-bottom">
                </div>
                <div class="card-cell">
                  <label>Major<br>Incidents</label>
                  <br />
                  <b>{{ currentState.pumpIncidents }}</b> <img v-if="currentState.pumpIncidents>=3" src="@/assets/img/alert-red.svg" valign="text-bottom">
                </div>
                <div class="card-space"></div>
                <label>Maintenance<br>&amp; Repairs</label>
                <br />
                <b>${{ currentState.repairCost.toFixed(2) }}</b>
              </div>
              <div
                class="card-footer"
                v-html="currentStars[1]"
              ></div>
            </div>
            <div class="analytics-results blue-bg">
              <div class="card-header">
                <div>Analytics</div>
                <div class="learn-more" v-if="!config.offline"><a href="https://www.ge.com/digital/applications/proficy-csense" target="_blank" ><img src="@/assets/img/arrow-round.svg" > Learn More</a></div>
              </div>
              <div class="card-content">
                <div class="analytics-col">
                  <label>Analytics Costs</label>
                  <br />
                  <b>${{ currentState.analyticsCost.toFixed(2) }}</b>
                  <div class="card-space"></div>
                  <label v-if="currentState.analyticsSaves>0">Saves You</label>
                  <label v-if="currentState.analyticsSaves==0">Missed Savings</label>
                  <br />
                  <b v-if="currentState.analyticsSaves>0">${{ currentState.analyticsSaves >= 1000 ? currentState.analyticsSaves.toFixed(0) : currentState.analyticsSaves.toFixed(2) }}</b>
                  <b v-if="currentState.analyticsSaves==0">${{ currentState.analyticsMissed.toFixed(2) }}</b>
                </div>
                <div class="analytics-col">
                  <label >&nbsp;</label>
                  <div class="pump-analytics">
                    <b>{{ currentState.analyticsPumps }}/{{ 3 }}</b><span class="pumps">Pumps</span>&nbsp;<img v-if="currentState.analyticsPumps==0 && currentState.pumpIncidents>0" src="@/assets/img/alert-red.svg" valign="text-bottom">
                  </div>
                  <div class="card-space"></div>
                  <label v-if="currentState.analyticsSaves>0">Missed Savings</label>
                  <b v-if="currentState.analyticsSaves>0">${{ currentState.analyticsMissed.toFixed(2) }}</b>
                </div>
              </div>
              <div class="card-footer">
                <div>
                  <label>Net Gain</label>
                  <br />
                  <b
                    >${{
                      (currentState.analyticsSaves - currentState.analyticsCost).toFixed(2)
                    }}</b
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="tower-results dark-bg" :failed="currentState.townIncidents>=limits.MIN_TOWN">
            <div class="card-header">Water Tower</div>
            <div class="card-content">
              <div class="card-cell">
                <label>Minor<br>Incidents</label>
                <br />
                <b>{{ currentState.townIssues }}</b>  <img v-if="currentState.townIssues>=3" src="@/assets/img/alert-red.svg" valign="text-bottom">
              </div>
              <div class="card-cell">
                <label>Major<br>Incidents</label>
                <br />
                <b>{{ currentState.townIncidents }}</b>  <img v-if="currentState.townIncidents>=3" src="@/assets/img/alert-red.svg" valign="text-bottom">
              </div>
              <div class="card-space"></div>
              <!--
              <label>Repair Costs</label>
              <br />
              <b>${{ (currentState.analyticsCost).toFixed(2) }}</b>
              -->
            </div>
            <div
              class="card-footer"
              v-html="currentStars[2]"
            ></div>
          </div>
        </div>
        <div class="global-results" >
          <div class="total-results dark-bg" :failed="currentState.totalCost>limits.MIN_TOTAL">
            <div class="card-header">Total Costs</div>
            <div class="card-content">
              <span>Power +<br />Pumps <span v-if="activeChallenge.number>1">+<br />Analytics</span></span>
              <div class="separator"></div>
              <label>Grand Total</label>
              <br />
              <b>${{ currentState.totalCost.toFixed(2) }}</b>
            </div>
            <div
              class="card-footer"
              v-html="currentStars[3]"
            ></div>
          </div>
          <div class="town-results dark-bg" :failed="customerSatisfaction<limits.MIN_SATISF">
            <div class="card-header">Water Town</div>
            <div class="card-content">
              <label>Customer Satisfaction</label>
              <br />
              <b
                >{{
                  customerSatisfaction.toFixed(0)
                }}%</b> <img v-if="customerSatisfaction<50" src="@/assets/img/alert-red.svg" valign="text-bottom">
            </div>
            <div
              class="card-footer"
              v-html="currentStars[4]"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="end-content" v-show="endCountdown==0 && showAll">
      <h2>Compare Your Results</h2>
      <p>See how you performed across all 3 challenges below</p>
      <div class="end-results" >
        <div class="level-result" v-for="chlg in challenges" :key="chlg.number" v-show="chlg.number>0" :level="chlg.level">
          <div class="summary-header" >{{chlg.level}} <i>{{$store.state.scores[chlg.number] ? 'Completed' : ($store.state.locks[chlg.number] ? 'Locked' : 'Not played')}}
            </i></div>
          <div class="summary-challenge">
            <img src="@/assets/img/level-unlocked.svg" v-if="(!config.offline || config.leaderboard) && !$store.state.locks[chlg.number]" height="32" >
            <img src="@/assets/img/level-locked.svg" v-if="(!config.offline || config.leaderboard) && $store.state.locks[chlg.number]" height="32">
            Challenge {{chlg.number}}
          </div>
          <div class="level-summary" :completed="$store.state.scores[chlg.number]>0">
            <div class="level-top-score" v-if="$store.state.scores[chlg.number]"><img src="@/assets/img/cup.svg" height="24" align="absmiddle"> Your Top Score</div>
            <div class="level-not-completed" v-if="!$store.state.scores[chlg.number]">Challenge not Completed</div>
            <div class="level-score-detail" :score="$store.state.scores[chlg.number]">
              <div class="level-score">{{$store.state.scores[chlg.number] || '0'}}</div>
              <div class="level-details" v-if="!$store.state.locks[chlg.number] && $store.state.scores[chlg.number] > 0" @click="setCurrentResults(chlg.number)">
                <img src="@/assets/img/arrow-right-round.svg" width="24" align="left">
                <div>View Results Breakdown</div>
              </div>
            </div>
          </div>
          <div class="level-summary-buttons" v-if="!$store.state.locks[chlg.number]">
            <button :class="['action-button', config.offline ? 'action-disabled' : null]" @click="restartChallenge(chlg.number)" v-if="$store.state.scores[chlg.number] > 0">Play Again</button>
            <button :class="['action-button']" @click="restartChallenge(chlg.number)" v-if="$store.state.scores[chlg.number] == 0">Start Challenge</button>
            <button :class="['action-button', 'action-disabled']"  v-if="!config.offline && $store.state.scores[chlg.number] > 0" @click="shareGame($store.state.scores[chlg.number])">Share Score</button>
          </div>
          <div class="level-summary-buttons" v-if="$store.state.locks[chlg.number]">
            <button :class="['action-button', !config.offline ? null : 'action-hidden' ]" @click="nextChallenge(chlg.number)">Unlock</button>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="end-footer"  v-show="endCountdown==0">
      <div class="simulation-points" v-if="!showAll">
        <div class="score-label">Your Score</div>
        <div class="score-value">{{finalScore}}</div>
        <div class="score-best" v-if="personalBest">
          <div class="best-icon"></div>
          <div class="best-label">Personal<br>Best</div>
        </div>
      </div>
      <div class="left-margin right-margin white-separator"></div>
      <div class="end-buttons" v-if="!showAll">
        <button :class="['action-button',(!currentState.challengeFailed && activeChallenge.number<=2)?'action-disabled':null]" @click="restartChallenge()">Try Again</button>
        <button v-if="!currentState.challengeFailed && activeChallenge.number<=2" :class="['action-button']" @click="nextChallenge()">Next Level</button>
        <button class="action-button action-disabled" v-if="!config.offline" @click="shareGame(finalScore)">Share Score</button>
        <button class="action-button action-results" v-if="!showAll && finishedChallenge > 0" @click="seeAll()">See All Results</button>
        <button class="action-button action-backresults" v-if="!showAll && finishedChallenge == 0" @click="seeAll()">Back to Results</button>
      </div>
      <div class="end-buttons" v-if="showAll">
        <button class="action-button hide-standalone" @click="shareGame(null)">Share Game</button>
        <button class="action-button action-backresults" v-if="!allresults" @click="seeSummary()">Back to Summary</button>
      </div>
      <div class="scroll-down hide-standalone">
        Scroll down to learn more about GE Digital's HMI/SCADA and analytics capabilities
        <br>
        <a @click="scrollDown()" ><img src="@/assets/img/arrow-down-small.svg" width="14" height="16"></a>
      </div>
      <Share :active="share" v-if="share" @hide="share=false" :score="shareScore" :challenge="activeChallenge.number"></Share>
    </div>
  </div>
</template>

<script>
import simulation from '@/lib/simulation.js'
import challenges from '@/assets/json/challenges.json'
import Share from '@/components/Share.vue'
import limits from '@/lib/limits.js'
import config from '@/config.js'

export default {
  data: function () {
    return {
      simulation: simulation,
      challenges: challenges,
      scores: [0, 0, 0, 0, 0],
      share: false,
      shareScore: null,
      endCountdown: 5,
      active: false,
      limits: limits[0],
      showAll: false,
      activeChallenge: { number: 0 },
      finishedChallenge: 0,
      config: config
    }
  },
  components: {
    Share
  },
  methods: {
    setCurrentResults: function (num, restore) {
      this.activeChallenge = challenges[num]
      if (num === this.finishedChallenge) {
        this.finishedChallenge = 0
      }
      if (restore) {
        this.finishedChallenge = num
      }
      this.showAll = false
      this.limits = limits[num]
      this.$forceUpdate()
    },
    shareGame: function (points) {
      if (points) {
        this.shareScore = points
      } else {
        this.shareScore = null
      }
      this.share = true
    },
    exitChallenge: function () {
      this.$emit('exit')
    },
    restartChallenge: function (chlg) {
      if (!chlg) {
        chlg = this.activeChallenge.number
      }
      this.$emit('restart', chlg)
    },
    nextChallenge: function (chlg) {
      if (!chlg) {
        chlg = this.activeChallenge.number + 1
      }
      if (simulation.challengeNumber === chlg) {
        this.$emit('restart', chlg)
      } else {
        this.$emit('next', chlg)
      }
    },
    fix: function (value, digits) {
      if (value === null || !value.toFixed) {
        return 0
      }
      return value.toFixed(digits)
    },
    scrollDown: function () {
      parent.postMessage('scrolldown', '*')
    },
    stars: function (idx, value, min, max) {
      this.limits = limits[this.activeChallenge.number]
      const items = []
      const star1 = '<div class="star-icon star-full" ></div>'
      const star0 = '<div class="star-icon star-empty" ></div>'
      const star12 = '<div class="star-icon star-half" ></div>'
      let count = 0
      let pos = 0
      if (min > max) {
        pos = (value - max) / (min - max)
        if (value <= max) {
          count = 3
        } else if (value > min) {
          count = 0
        } else if (pos < 0.25) {
          count = 2.5
        } else if (pos <= 0.5) {
          count = 2
        } else if (pos < 0.75) {
          count = 1.5
        } else {
          count = 1
        }
      } else {
        pos = (value - min) / (max - min)
        if (min > 0 && value === 0) {
          count = 0
        } else if (value < min) {
          count = 0
        } else if (value >= max) {
          count = 3
        } else if (pos > 0.75) {
          count = 2.5
        } else if (pos >= 0.5) {
          count = 2
        } else if (pos > 0.25) {
          count = 1.5
        } else if (value >= min) {
          count = 1
        }
      }
      // window.console.log(idx, value.toFixed(1), count, pos.toFixed(2), value, min, max, this.activeChallenge.number)
      items.push(star0)
      items.push(star0)
      items.push(star0)
      if (count >= 1) {
        items[0] = star1
      }
      if (count >= 2) {
        items[1] = star1
      }
      if (count === 3) {
        items[2] = star1
      }
      if (count === 2.5) {
        items[2] = star12
      }
      if (count === 1.5) {
        items[1] = star12
      }
      this.scores[idx] = count
      return items.join('')
    },
    seeAll: function () {
      this.showAll = true
    },
    seeSummary: function () {
      this.setCurrentResults(simulation.challengeNumber, true)
      this.$forceUpdate()
    },
    simulationScore: function () {
      let points = 0
      let score = 0
      const gameFactor = Number(this.currentState.currentTime / simulation.params.END_TIME)
      const factor = this.currentState.challengeFailed ? gameFactor : 1.0
      for (const idx in this.scores) {
        const pts = this.scores[idx]
        points += pts
        score += (pts * pts * pts * 74.0) * factor * 1
      }
      if (config.leaderboard) {
        score = (points * 6.6667) * (points * 6.6667) // (100 pts max) ^ 2 = 10000 max
        if (this.currentState.challengeFailed) {
          score = 0
        }
      }
      return Math.round(score)
    },
    saveScore: function (chNum) {
      if (chNum === 0) {
        return
      }
      const isMax = (this.simulationScore() >= this.$store.state.scores[chNum])
      this.$store.state.scores[chNum] = Math.max(this.simulationScore(), this.$store.state.scores[chNum])
      if (isMax) {
        this.$store.state.finalStates[chNum] = JSON.parse(JSON.stringify(this.currentState))
        this.$store.state.finalStates[chNum].events = []
        this.$store.state.finalStates[chNum].finalScore = this.finalScore
      }
      this.$store.state.userData.maxScores = JSON.parse(JSON.stringify(this.$store.state.scores))
      if (this.activeChallenge.number < 3) {
        this.$store.state.locks[this.activeChallenge.number + 1] = false
      }
      this.$store.state.userData.locks = JSON.parse(JSON.stringify(this.$store.state.locks))
      this.$store.state.userData.finalStates = JSON.parse(JSON.stringify(this.$store.state.finalStates))
      this.$store.state.userData.totalScore = 0
      for (const idx in this.$store.state.userData.maxScores) {
        if (idx > 0) {
          this.$store.state.userData.totalScore += this.$store.state.userData.maxScores[idx]
        }
      }
      this.$store.dispatch('store')
      this.$store.dispatch('saveFiles')
    }
  },
  created: function () {
    if (this.allresults) {
      this.showAll = true
      this.endCountdown = 0
      const scores = this.$store.state.scores
      for (let i = 1; i < scores.length; i++) {
        if (scores[i] > 0) {
          simulation.challengeNumber = i
          break
        }
      }
    }
  },
  mounted: function () {
    this.activeChallenge = challenges[simulation.challengeNumber]
    this.finishedChallenge = simulation.challengeNumber
    const self = this
    self.limits = limits[this.activeChallenge.number]
    if (this.endCountdown > 0) {
      const countProcess = setInterval(function () {
        self.endCountdown--
        self.$forceUpdate()
        if (self.endCountdown === 0) {
          clearTimeout(countProcess)
        }
        self.$nextTick(function () {
        })
      }, 1000)
    }
    setTimeout(function () {
      self.active = true
      self.$forceUpdate()
    }, 100)
  },
  props: {
    allresults: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentStars: function () {
      const currentStars = [0, 0, 0, 0, 0]
      const activeLimits = limits[this.activeChallenge.number]
      currentStars[0] = this.stars(0, this.currentState.totalPowerCost * this.timeFactor, activeLimits.MIN_POWER, activeLimits.MAX_POWER)
      currentStars[1] = this.stars(1, this.currentState.repairCost, activeLimits.MIN_REPAIR, activeLimits.MAX_REPAIR)
      currentStars[2] = this.stars(2, this.currentState.townIncidents + this.currentState.townIssues / 3, activeLimits.MIN_TOWN, activeLimits.MAX_TOWN)
      currentStars[3] = this.stars(3, this.currentState.totalCost, activeLimits.MIN_TOTAL, activeLimits.MAX_TOTAL)
      currentStars[4] = this.stars(4, Math.round(this.customerSatisfaction), activeLimits.MIN_SATISF, activeLimits.MAX_SATISF)
      if (this.activeChallenge.number === this.finishedChallenge && !this.allresults) {
        this.saveScore(this.activeChallenge.number)
        simulation.saved = true
      }
      return currentStars
    },
    finalScore: function () {
      return this.simulationScore()
    },
    personalBest: function () {
      const chNum = this.activeChallenge.number
      const score = this.simulationScore()
      if (score > 0 && score >= this.$store.state.scores[chNum]) {
        return true
      }
      return false
    },
    currentState: function () {
      const activeState = this.$store.state.finalStates[this.activeChallenge.number]
      if (activeState && activeState.currentTime >= 0 && this.finishedChallenge !== this.activeChallenge.number) {
        return activeState
      } else {
        if (this.allresults) {
          return this.$store.state.finalStates[simulation.challengeNumber]
        } else {
          return simulation.data
        }
      }
    },
    challenge: function () {
      return this.challenges[this.activeChallenge.number]
    },
    customerSatisfaction: function () {
      return (this.currentState.customerSatisfaction * 100) / this.currentState.customerSatisfactionExpected
    },
    timeFactor: function () {
      let factor = simulation.params.END_TIME / this.currentState.currentTime
      if (this.currentState.challengeFailed) {
        factor *= 2
      }
      return factor
    },
    totalIncidents: function () {
      return (this.currentState.pumpIncidents + this.currentState.townIncidents)
    },
    cummulativeTimeout: function () {
      return (this.currentState.totalMinutesEmpty > this.currentState.towerEmptyTimeout) || (this.currentState.totalMinutesOverflow > this.currentState.towerOverflowTimeout)
    },
    resultsLevel: function () {
      let result = 3
      if (this.totalIncidents > 0) {
        result = 2
      }
      if (this.totalIncidents >= 3 || this.cummulativeTimeout) {
        result = 1
      }
      if (this.currentState.challengeFailed) {
        result = 0
      }
      return result
    },
    analyticsNet: function () {
      return this.currentState.analyticsSaves - this.currentState.analyticsCost - this.currentState.analyticsMissed
    },
    netRepairCost: function () {
      if (this.analyticsNet > 0) {
        return this.currentState.repairCost - this.analyticsNet
      }
      return this.currentState.repairCost
    },
    totalNetCost: function () {
      if (this.analyticsNet > 0) {
        return this.currentState.totalCost - this.analyticsNet
      }
      return this.currentState.totalCost
    }
  }
}
</script>

<style lang="scss" scoped>
.endchallenge {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity linear 1s;
  &[active='true']{
    opacity: 1;
  }
  &[showall]{
    display: block;
  }
  .action-button.action-squared{
    z-index: 1;
  }
  .action-button.action-results{
    position: absolute;
    padding-right: 50px;
    background-image: url(../assets/img/arrow-right.svg);
    background-size: 32px 32px;
    background-position: 92% center;
    right: 0;
  }
  .action-button.action-backresults{
    position: absolute;
    right: 0;
  }
  .end-header {
    height: 100px;
    display: flex;
    margin: 0 auto;
    width: 100%;
    padding: 0 5%;
    justify-content: space-between;
    align-items: flex-end;
    .challenge-level {
      height: 50px;
      padding: 0 20px;
      border-radius: 5px 5px 0 0;
      background-color: #444;
      color: #fff;
      line-height: 50px;
      min-width: 80px;
      text-transform: uppercase;
      font-weight: bold;
    }
    .challenge-title {
      text-align: left;
      flex: 1;
      margin: 0 20px;
      line-height: 50px;
      text-transform: uppercase;
      font-weight: bold;
    }
    .action-button {
      height: 50px;
      line-height: 50px;
      margin-bottom: 8px;
    }
  }
  .end-content {
    flex: 1;
    width: 100%;
    h2 {
      font-size: 52px;
      margin-top: 4vh;
      margin-bottom: 2vh;
      span{
        font-weight: normal;
      }
    }
    p {
      font-size: 22px;
    }
    .end-results {
      width: 95%;
      max-width: 1600px;
      margin: 30px auto;
      height: 330px;
      display: flex;
      justify-content: center;
      text-transform: uppercase;
      text-align: left;
      > div {
        height: 100%;
      }
      *[failed='true']{
        box-shadow: 0px 0px 10px 10px rgba(255,0,0,0.5);
        border: 4px solid #f00;
        border-radius: 7px;
      }
      .action-hidden{
        visibility: hidden;
      }
      .detailed-results {
        padding: 30px;
        box-sizing: border-box;
        border-radius: 25px;
        background-color: rgba(255, 255, 255, 0.15);
        width: 66%;
        display: flex;
        justify-content: space-between;
        > div {
          height: 100%;
          flex: 1 1 22%;
          border-radius: 5px;
          overflow:hidden;
        }
        .main-results{
          display: flex;
          flex: 1 1 50%;
        }
        .power-results {
          margin-right: 3%;
        }
        .pump-results{
          flex: 1 0 45%;
        }
        .analytics-results {
          flex: 1 0 55%;
          .card-content {
            display: flex;
            justify-content:space-between;
            .analytics-col:first-child{
              margin-right: 3%;
            }
          }
          .pump-analytics{
            white-space: nowrap;
          }
          a:link, a:visited, a:active{
            color: #fff;
            text-decoration: none;
            line-height: 2em;
          }
          a:hover{
            text-decoration: underline;
          }
          .card-header{
            display: flex;
            justify-content: space-between;
            img{
              vertical-align:middle;
              display: inline-block;
              padding-right: 4px;
            }
            .learn-more{
              font-size: 12px;
              text-transform: none;
              font-weight: normal;
            }
          }
          .card-footer {
            display: block;
            line-height: normal;
            text-align: left;
            padding: 0 20px;
            label {
              font-weight: normal;
              line-height: 1em;
              height: 1.1em;
              margin-bottom: 0;
            }
          }
        }
        &[short='true']{
          > div {
            height: 100%;
            flex: 1 1 30%;
          }
          .analytics-results {
            display: none;
          }
        }
        .tower-results {
          margin-left: 3%;
        }
      }
      .level-result{
        width: 500px;
        height: 470px;
        margin: 0 0.75vw;
        border-radius: 10px;
        background-color: #16191D;
        display: flex;
        flex-direction: column;
        .summary-header{
          line-height: 3em;
          padding: 0 16px;
          font-weight: bold;
          border-radius: 5px 5px 0 0;
          font-size: 1;
        }
        .summary-challenge{
          line-height: 2.5em;
          font-size: 36px;
          text-align: center;
          text-transform: none;
        }
        .level-summary{
          text-align: center;
          flex: 1;
          display: flex;
          justify-content:center;
          align-items:center;
          flex-direction: column;
        }
        .level-top-score{
          padding: 6px 0 0 0;
        }
        .level-top-score, .level-not-completed{
          margin: 0;
          font-size: 20px;
        }
        .level-top-score img{
          padding-right: 10px;
          height: 28px;
        }
        .level-score-detail{
          margin: 2vh 0;
          font-weight: bold;
          position: relative;
          width: 100%;
          &[score='0'] .level-score{
            color: #282622;
            background-color:#FFFFFF40;
          }
          .level-score{
            font-size: 48px;
            min-width: 40%;
            background-color: #fff;
            color: #444;
            display: inline-block;
            margin: 0 auto;
            padding: 0 0.5em;
            border-radius: 10px;
            height: 75px;
            line-height: 75px;
          }
          .level-details{
            position: absolute;
            cursor: pointer;
            height: 75px;
            font-size: 14px;
            align-items:center;
            right: 0;
            top: 0;
            width: 120px;
            font-weight: normal;
            text-transform: none;
            text-align: left;
            display: flex;
            div{
              padding-left: 10px;
              display: inline-block;
            }
          }
        }
        .level-summary-buttons{
          padding: 3vh 0;
          border-top: 2px solid rgba(255, 255, 255, 0.33);;
          text-align: center;
          .action-button{
            margin: 0 0.5vw;
          }
        }
        &[level='Easy']{
          border: 5px solid #00A84933;
          .summary-header{
            background-color: #00A849;
            color: #fff;
          }
          .summary-challenge{
            background-color: #00A84920;
          }
        }
        &[level='Intermediate']{
          border: 5px solid #F1C40F33;
          .summary-header{
            background-color: #F1C40F;
            color: #fff;
          }
          .summary-challenge{
            background-color: #F1C40F20;
          }
        }
        &[level='Hard']{
          border: 5px solid #F4505033;
          .summary-header{
            background-color: #F45050;
            color: #fff;
          }
          .summary-challenge{
            background-color: #F4505020;
          }
        }
      }
      .global-results {
        width: 30%;
        padding: 30px;
        padding-right: 5px;
        display: flex;
        > div {
          height: 100%;
          width: 50%;
          border-radius: 5px;
          overflow: hidden;
        }
        .total-results {
          margin-right: 3%;
        }
        .town-results {
          margin-left: 3%;
        }
      }
      .card-header {
        height: 50px;
        line-height: 50px;
        text-align: left;
        padding: 0 20px;
        font-weight: bold;
        border-bottom: 2px solid #444;
      }
      .card-content {
        flex: 1;
        padding: 16px 20px;
        .card-cell{
          width: 50%;
          display: inline-block;
        }
        img{
          width:21px;
        }
        .analytics-col{
          min-width: 48%;
        }
      }
      label {
        font-size: 12px;
        line-height: 1.2em;
        height: 28px;
        vertical-align:bottom;
        display: inline-flex;
        align-items: flex-end;
        margin-bottom: 4px;
        color: #acacac;
        white-space: nowrap;
      }
      b {
        font-size: 24px;
        line-height: 28px;
        display: inline-block;
      }
      span {
        font-size: 12px;
        &.pumps{
          text-transform: none;
          padding-right: 4px;
        }
      }
      .card-space{
        height: 12px;
        overflow: hidden;
      }
      .card-footer {
        height: 55px;
        line-height: 55px;
        text-align: left;
        font-weight: bold;
        text-align: center;
        background-color: #21272e;
        display: flex;
        justify-content: center;
        align-items: center;
        > img {
          display: inline-block;
          margin: 0 8px;
          vertical-align: middle;
        }
      }
      .dark-bg {
        background-color: #16191d;
        color: #fff;
        flex-direction: column;
        display: flex;
        .card-header {
          border-bottom: 2px solid #373e46;
        }
      }
      .blue-bg {
        background-color: #00b5e2;
        flex-direction: column;
        display: flex;
        label {
          color: #fff;
        }
        .card-header {
          border-bottom: 2px solid #00a9d4;
        }
        .card-footer {
          background-color: #00a9d4;
        }
      }
    }
  }
  .end-footer {
  }
  &[level="Easy"] {
    .end-header {
      border-bottom: 2px solid #00a849;
      .challenge-level {
        background-color: #00a849;
      }
    }
  }
  &[level="Intermediate"] {
    .end-header {
      border-bottom: 2px solid #ffcc01;
      .challenge-level {
        background-color: #ffcc01;
      }
    }
  }
  &[level="Hard"] {
    .end-header {
      border-bottom: 2px solid #f45050;
      .challenge-level {
        background-color: #f45050;
      }
    }
  }
  .end-header.all-results {
    border-bottom: 2px solid rgba(255, 255, 255, 0.33);
  }
}
div.separator {
  display: block;
  height: 8px;
}
.end-buttons{
  width: 95%;
  margin: 0 auto;
  position: relative;
  .action-button{
    margin: 1vw 12px;
  }
}
.end-splash{
  display: flex;
  flex-direction: column;
  justify-content:space-between;
  height: 100%;
  width: 100%;
  .splash-header{
    flex: 1 1 50%;
    display: flex;
    justify-content:center;
    align-items: flex-end;
    padding: 30px;
    font-size: 52px;
    border-bottom: 2px solid #00a849;
    b{
      font-style: italic;
      padding-left: 10px;
    }
  }
  .splash-content{
    flex: 1 1 45%;
    display: flex;
    justify-content:center;
    align-items: flex-start;
    padding: 30px;
    font-size: 48px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .splash-footer{
    flex: 1 1 5%;
    margin-bottom: 8px;
  }
  .splash-countdown{
    width: 30px;
    height: 30px;
    display: inline-flex;
    position: relative;
    box-sizing: border-box;
    justify-content: center;
    align-items:center;
    &::before{
      content: ' ';
      position: absolute;
      border-radius:50%;
      border:4px solid rgba(19,125,172,0.8);
      border-top:4px solid rgba(19,125,172,0.1);
      height:30px;
      margin:-1px 0px;
      width:30px;
      left: 0;
      top: 0;
      animation:spin 2s linear infinite;
      transform-origin: 15px 15px;
    }
  }
}
.endchallenge{
  &[failed="true"]{
    .splash-header {
      border-bottom: 2px solid #f45050;
    }
    .splash-content {
      font-style: italic;
    }
  }
}
.end-footer{
  width: 100%;
}
.white-separator{
  margin-top: 4vh;
  margin-bottom: 1vh;
}
@media (max-width: 1720px){
  .endchallenge .end-content .end-results .level-result{
    width: 440px;
    height: 440px;
  }
}
@media (max-height: 940px), (max-width: 1440px){
  .endchallenge .end-content .end-results .level-result{
    width: 420px;
    height: 420px;
    .summary-challenge{
      font-size: 24px;
      line-height: 80px
    }
    .level-score-detail .level-score{
      font-size: 36px;
      height:50px;
      line-height: 50px;
      min-width: 35%;
    }
    .level-score-detail .level-details{
      height:50px;
      font-size: 13px;
    }
    .action-button{
      padding: 0 30px;
    }
    .level-summary-buttons{
      padding: 20px 0;
    }
  }
}
@media (max-height: 880px) {
  .endchallenge .end-content .end-results{
    width: 95%;
    margin: 3vh auto;
    height: 280px;
    .card-header{
      white-space: nowrap;
      font-size: 14px;
    }
    b{
      font-size: 18px;
      line-height: 24px;
    }
    .card-content{
      padding: 12px 16px;
      img{
        width: 18px;
      }
    }
    label{
      margin-bottom: 0px;
    }
  }
  .endchallenge .end-content h2{
    font-size:44px;
  }
  .endchallenge .end-content p{
    font-size:20px;
  }
  .endchallenge .end-content .end-results .detailed-results{
    padding: 16px;
    .power-results{
        margin-right: 2%;
    }
    .tower-results{
        margin-left: 2%;
    }
  }
  .endchallenge .end-content .end-results .global-results{
    padding: 16px;
  }
}
@media (max-width:1365px){
  .endchallenge .end-content .end-results .detailed-results .analytics-results .card-header .learn-more{
    font-size: 10px;
  }
  .endchallenge .end-content .end-results label{
    font-size: 10px;
  }
  .endchallenge .end-content .end-results .card-header{
    font-size: 12px;
  }
  .endchallenge .end-content .end-results{
    .detailed-results, .global-results{
      padding: 16px;
    }
  }
}
@media (max-height: 840px), (max-width: 1365px){
  .endchallenge .end-content .end-results .level-result{
    width: 390px;
    height: 370px;
    .level-score-detail .level-score{
      font-size: 32px;
      min-width: 30%;
    }
  }
}
@media (max-height: 800px), (max-width: 1280px){
  .endchallenge .end-content .end-results .level-result{
    width: 360px;
    height: 350px;
    .level-score-detail .level-score{
      font-size: 24px;
      min-width: 30%;
    }
    .action-button{
      padding: 0 20px;
      font-size: 16px;
      line-height: 20px;
    }
    .level-score-detail{
      margin: 8px 0;
      .level-details{
        width: 100px;
      }
    }
  }
}
@media (max-height: 800px) {
  .endchallenge .end-content h2{
    font-size:32p x;
  }
  .endchallenge .end-content p{
    font-size:18px;
  }
  .endchallenge .end-content .end-results{
    width: 100%;
    height: 260px;
    .card-header{
      height: 40px;
      line-height: 40px;
    }
    .card-footer, .card-header{
      box-sizing: border-box;
      padding-left: 12px;
      padding-right: 12px;
    }
    .card-content{
      box-sizing: border-box;
      padding: 8px 12px;
      img{
        width: 16px;
      }
    }
    .detailed-results .analytics-results .card-footer{
      padding: 0 12px;
    }
  }
  .endchallenge .end-content h2{
    margin-top: 20px;
  }
  .endchallenge .end-content .end-results label{
    font-size: 10px;
  }
  .endchallenge .end-content .end-results .detailed-results .analytics-results .pump-analytics{
    margin-bottom: 2px;
    b{
      font-size: 14px;
    }
    img{
      width: 16px;
      height: 16px;
    }
  }
  .end-buttons .action-button{
    margin: 0 12px;
  }
  .simulation-points{
    margin: 8px 0;
  }
  .endchallenge .end-header{
    height: 80px;
  }
}
@media (max-height: 700px), (max-width: 1120px){
  .endchallenge .end-content .end-results .level-result{
    width: 320px;
    height: 290px;
    .summary-header{
      line-height: 2.5em;
    }
    .summary-challenge{
      font-size: 20px;
      line-height: 60px;
      > img {
        height: 22px;
      }
    }
    .level-score-detail .level-score{
      font-size: 24px;
      height:50px;
      line-height: 50px;
      min-width: 30%;
    }
    .level-top-score, .level-not-completed{
      font-size: 16px;
      > img {
        height: 20px;
      }
    }
    .level-summary-buttons{
      padding: 12px 0;
    }
  }
}
@media (max-height: 700px) {
  .endchallenge .end-content .end-results{
    margin: 8px auto;
    b{
      font-size: 16px;
      line-height: 22px;
    }
    .card-content img{
      width: 16px;
    }
  }
  .endchallenge .end-header .action-button{
    height: 40px;
    line-height: 40px;
    padding: 0 30px;
    font-size: 14px;
  }
  .endchallenge .end-header{
    .challenge-level, .challenge-title{
      height: 40px;
      line-height: 40px;
    }
  }
}
@media (max-height: 660px) {
  .scroll-down{
    margin-top: 10px;
    font-size: 14px;
    img{
      margin: 6px 0;
    }
  }
  .endchallenge .end-content{
    h2{
      font-size: 28px;
      margin: 8px 0 4px 0;
    }
    p{
      font-size: 16px;
    }
    .end-results{
      height: 240px;
      max-width: 1200px;
      .card-content{
        padding: 4px 12px;
      }
      .card-space{
        height: 4px;
      }
      .card-footer{
        height: 40px;
      }
    }
    .detailed-results .analytics-results .card-footer label{
      line-height: 10px !important;
      vertical-align:text-bottom;
    }
  }
  .white-separator{
    margin: 8px 0 12px 0;
  }
}
</style>
<style lang="scss">
.star-icon {
  width: 37px;
  height: 35px;
  max-width: 1.85vw;
  max-height: 1.75vw;
  background-repeat: no-repeat;
  background-size:contain;
  margin: 0 8px;
  &.star-empty {
    background-image: url("../assets/img/star-empty.svg");
  }
  &.star-full {
    background-image: url("../assets/img/star-full.svg");
  }
  &.star-half {
    background-image: url("../assets/img/star-half.svg");
  }
}
</style>
